// Feature flags — cambia a `true` para reactivar la campaña Starlink Mini
// (footer, banner superior, bloque en home, ruta /reserva-starlink-mini,
// panel admin /admin/reservas y todos los enlaces asociados).
export const STARLINK_ENABLED = false;
